class DZModelDicConfig{
    dicMap = new Map([
        ["流转类型","1766850840056774657"],
        ["土地标签","1766850867898564609"],
        ["租赁方式","1766850947783278593"],
        ["厕所类型","1766850970495434753"],
        ["房屋类型","1766850993815764994"],
        ["信息类型","1766851110136397825"],
        ["权证类型","1766851188603437058"],
        ["房屋配置","1766851255628414977"],
        ["房屋亮点","1766851275408752641"],
        ["装修程度","1766851327590088706"],
        ["土地用途","1768542154654213512"],
        ["地区选择地域","1769982165701353474"],
        ["地区选择城市","1769988853087068161"],
        ["地区选择地区","1769989811347120130"],
        ["面积","1769993513629900802"],
        ["流转年限","1769996279806943234"],
        ["选择土地小类","1770328846003269633"],
        ["权属类型","1770329244902551554"],
        ["土地状态","1770331042505748482"],
        ["添加土地标签","1770331568211423233"],
        ["选择土地大类","1770344249744093185"],
        ["选择民宿大类","1770618569091358722"],
        ["选择民宿小类","1770629209583435778"],
        ["厢房厕所","1770654402230009858"],
        ["房屋朝向","1770654645973598210"],
        ["水电费","1770655022211055617"],
        ["面积单位","1770718093470253058"],
        ["期望价格单位","1772095534531301377"],

        ['power','1772429090063310850'],
        ['water','1772429132534833154'],
        ['heating','1772429175086047233'],
        ['energy','1772429215657549825'],
        ['communicate','1772429238080299010'],
        ['television','1772429273480224769'],
        ['network','1772429296787972098'],
        ['sewageTreatment','1772429329822310402'],
        ['greeningDegree','1772429362139422722'],
        ['parkingFacilities','1772429429189566466'],
        ['educationFacility','1772429458990096385'],
        ['medicalCenter','1772429480125194242'],
        ['generalSanitation','1772429521107738625'],
        ['entertainment','1772429551151538178'],
        ['diet','1772429578083164162'],
        ['commercialService','1772429607166468097'],
        ['governmentAgencies','1772429643665301506'],
        ['housingConfiguration','1766851255628414977'],
        ['housingHighlights','1766851275408752641'],
        ['toAirport','1772452909880631297'],
        ['toSpeed','1772452943019827202'],
        ['toRailway','1772452961906778114'],
        ['toPort','1772454382710480898'],
        ['toHeightSpeed','1772454407184244737'],
        ['toProvincialRoad','1772454430412300289'],
        ['toNationalHighway','1772454454164643842'],
        ['toCountyHighway','1772454474561544193'],
        ['toTownshipHighway','1772454497743462402'],
        ['toVillageRoad','1772454522879926273'],
        ['toTransit','1772454544140853250'],
        ['houseAreaUnit','1770718093470253058'],
        ['totalAreaUnit','1770718093470253058'],
        ['areaUnit', '1770718093470253058'],
        ['priceUnit','1772095534531301377'],
        ['leasingMethod','1766850947783278593'],
        ['decorationLevel','1766851327590088706'],
        ['toiletType','1766850970495434753'],
        ['supportingFacilities','1766851255628414977'],
        ['houseOrientation','1770654645973598210'],
        ['waterElectricityFees','1770655022211055617'],
        ['homestayBigType','1770618569091358722'],
        ['homestaySmallType','1770629209583435778'],

        /** 气候降雨 **/
        ['climateType','1776116038124666882'],
        ['sunlightDuration','1776116464798629889'],
        ['sunshineRate','1776116628867219457'],
        ['averageTemperature','1776116708684824577'],
        ['frostfreePeriod','1776116787730677762'],
        ['rainfall','1776116853900017665'],
        ['humidity','1776116909432602626'],

        /** 土壤土质 **/
        ['soilFertility','1776115169920516097'],
        ['thickness','1776115265689059329'],
        ['salinization','1776115432349728770'],
        ['soilTexture','1776115663430713345'],
        ['soilPh','1776115751951499265'],
        ['organicContent','1776115843571875842'],
        ['groundwaterDepth','1776115959062036481'],

        /** 地形地貌 **/
        ['terrainSlope','1776114061844119554'],
        ['altitude','1776114173244833794'],
        ['lotShape','1776114284616187906'],
        ['flatness','1776114377335472130'],
        ['drainedCondition','1776114457715113985'],
        ['irrigationCondition','1776114529534181377'],
        ['position','1776114609506975745'],
        ['landforms','1776114673587552257']

    ])

    get(key) {
        return this.dicMap.get(key)
    }
}
export default DZModelDicConfig
